// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-dropdown {
    width: 100%;
    max-width: 20vw;
    position: relative;
}

.custom-dropdown .text-label {
    border: none;
    padding: 2%;
}

.custom-dropdown .text-label.error {
    color: red;
}


.custom-dropdown .inputbox-container {
    display: flex;
    align-items: center;
    border: 1.5px solid black;
    border-radius: 4px;
}
.custom-dropdown .inputbox-container.error {
    border-color: red!important;
}

.custom-dropdown .inputbox-container .clear-all{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 2%;
}

.custom-dropdown .inputbox-container input{
    border: none;
    padding: 3%;
    width: 90%;
    color: black;
    text-align: center;
}

.custom-dropdown .inputbox-container input::placeholder{
    color: black;
}

.custom-dropdown .dropdown-container {
    border: 1px solid rgba(0, 0, 0, 0.5);
    position: absolute;
    z-index: 100;
    background: white;
    max-height: 32vh;
    overflow-y: auto;
    width: 100%;
}

.custom-dropdown .dropdown-container .items-list{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.custom-dropdown .dropdown-container .items-list:hover {
    cursor: pointer;
}

.custom-dropdown .dropdown-container .items-list.selected {
    background-color: rgba(44, 202, 255, 0.17);
    border-bottom: 1px solid #a59e9e;
}

.custom-dropdown .dropdown-container .items-list.new .option{
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 2%;
    font-size: larger;
    margin-left: 5%;
}

.custom-dropdown .dropdown-container .list-item {
    width: 100%;
    display: flex;
    padding: 4%;
    align-items: center;
    justify-content: start;
}

.custom-dropdown .dropdown-container .list-item.selected {
    background-color: rgba(44, 202, 255, 0.17);
}

.custom-dropdown .dropdown-container .list-item input{
    margin-right: 5%;
    align-items: center;
}

.custom-dropdown .dropdown-container .list-item span{
    overflow-wrap: break-word;
    padding-right: 2%;
    width: 85%;
    text-align: start;
}

.dropdown-container2 {
    border: 1px solid;
    background: white;
    position: absolute;
    z-index: 100;
    max-height: 32vh;
    overflow-y: auto;
    width: 100%;
}

.dropdown-container2 .selections {
    background-color: var(--dropdown-select);
}

.dropdown-container2 .option { 
    display: flex;
    padding: 1vh 0;
}

.dropdown-container2 .option:hover {
    cursor: pointer;
}
.dropdown-container2 .option:first-child {
    padding-top: 2vh;
}

.dropdown-container2 .option:last-child:not(:first-child) {
    padding-bottom: 2vh;
}

.dropdown-container2 .option .checkbox { 
    display: flex;
    justify-content: center;
    align-items: center;
    width: 4vh;
    height: 2vh;
    padding: 0 1vh;
}

.dropdown-container2 .option .checkbox input {
    height: 2vh;
    width: 2vw;
}

.dropdown-container2 .option .checkbox input:hover {
    cursor: pointer;
}

.dropdown-container2 .option .checkbox input:checked {
    color: var;
}

.dropdown-container2 .option .text{ 
    display: flex;
    justify-content: start;
    align-items: center;
    text-align: start;
    padding: 0 0.5vw;
    flex-grow: 1;
}

.dropdown-container2 .option .text:only-child span {
    width: 100%;
    text-align: center;
}

.dropdown-inputbox {
    display: flex;
    align-items: center;
    border: 1.5px solid black;
    border-radius: 4px;
}

.dropdown-inputbox.error {
    border-color: red!important;
}

.dropdown-inputbox .clear-all{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 2%;
}

.dropdown-inputbox .clear .icon {
    margin: 0!important;
}

.dropdown-inputbox .inputbox{
    flex-grow: 1;
}

.dropdown-inputbox input{
    border: none;
    padding: 3%;
    width: 90%;
    color: black;
    text-align: center;
}

.dropdown-inputbox input::placeholder{
    color: black;
}


/* Hide scrollbar for Chrome, Safari and Opera */
/* .dropdown-container2::-webkit-scrollbar {
    display: none;
} */
  `, "",{"version":3,"sources":["webpack://./src/components/Dropdown/Dropdown.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;;AAGA,gDAAgD;AAChD;;GAEG","sourcesContent":[".custom-dropdown {\n    width: 100%;\n    max-width: 20vw;\n    position: relative;\n}\n\n.custom-dropdown .text-label {\n    border: none;\n    padding: 2%;\n}\n\n.custom-dropdown .text-label.error {\n    color: red;\n}\n\n\n.custom-dropdown .inputbox-container {\n    display: flex;\n    align-items: center;\n    border: 1.5px solid black;\n    border-radius: 4px;\n}\n.custom-dropdown .inputbox-container.error {\n    border-color: red!important;\n}\n\n.custom-dropdown .inputbox-container .clear-all{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-left: 2%;\n}\n\n.custom-dropdown .inputbox-container input{\n    border: none;\n    padding: 3%;\n    width: 90%;\n    color: black;\n    text-align: center;\n}\n\n.custom-dropdown .inputbox-container input::placeholder{\n    color: black;\n}\n\n.custom-dropdown .dropdown-container {\n    border: 1px solid rgba(0, 0, 0, 0.5);\n    position: absolute;\n    z-index: 100;\n    background: white;\n    max-height: 32vh;\n    overflow-y: auto;\n    width: 100%;\n}\n\n.custom-dropdown .dropdown-container .items-list{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.custom-dropdown .dropdown-container .items-list:hover {\n    cursor: pointer;\n}\n\n.custom-dropdown .dropdown-container .items-list.selected {\n    background-color: rgba(44, 202, 255, 0.17);\n    border-bottom: 1px solid #a59e9e;\n}\n\n.custom-dropdown .dropdown-container .items-list.new .option{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    padding: 2%;\n    font-size: larger;\n    margin-left: 5%;\n}\n\n.custom-dropdown .dropdown-container .list-item {\n    width: 100%;\n    display: flex;\n    padding: 4%;\n    align-items: center;\n    justify-content: start;\n}\n\n.custom-dropdown .dropdown-container .list-item.selected {\n    background-color: rgba(44, 202, 255, 0.17);\n}\n\n.custom-dropdown .dropdown-container .list-item input{\n    margin-right: 5%;\n    align-items: center;\n}\n\n.custom-dropdown .dropdown-container .list-item span{\n    overflow-wrap: break-word;\n    padding-right: 2%;\n    width: 85%;\n    text-align: start;\n}\n\n.dropdown-container2 {\n    border: 1px solid;\n    background: white;\n    position: absolute;\n    z-index: 100;\n    max-height: 32vh;\n    overflow-y: auto;\n    width: 100%;\n}\n\n.dropdown-container2 .selections {\n    background-color: var(--dropdown-select);\n}\n\n.dropdown-container2 .option { \n    display: flex;\n    padding: 1vh 0;\n}\n\n.dropdown-container2 .option:hover {\n    cursor: pointer;\n}\n.dropdown-container2 .option:first-child {\n    padding-top: 2vh;\n}\n\n.dropdown-container2 .option:last-child:not(:first-child) {\n    padding-bottom: 2vh;\n}\n\n.dropdown-container2 .option .checkbox { \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 4vh;\n    height: 2vh;\n    padding: 0 1vh;\n}\n\n.dropdown-container2 .option .checkbox input {\n    height: 2vh;\n    width: 2vw;\n}\n\n.dropdown-container2 .option .checkbox input:hover {\n    cursor: pointer;\n}\n\n.dropdown-container2 .option .checkbox input:checked {\n    color: var;\n}\n\n.dropdown-container2 .option .text{ \n    display: flex;\n    justify-content: start;\n    align-items: center;\n    text-align: start;\n    padding: 0 0.5vw;\n    flex-grow: 1;\n}\n\n.dropdown-container2 .option .text:only-child span {\n    width: 100%;\n    text-align: center;\n}\n\n.dropdown-inputbox {\n    display: flex;\n    align-items: center;\n    border: 1.5px solid black;\n    border-radius: 4px;\n}\n\n.dropdown-inputbox.error {\n    border-color: red!important;\n}\n\n.dropdown-inputbox .clear-all{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-left: 2%;\n}\n\n.dropdown-inputbox .clear .icon {\n    margin: 0!important;\n}\n\n.dropdown-inputbox .inputbox{\n    flex-grow: 1;\n}\n\n.dropdown-inputbox input{\n    border: none;\n    padding: 3%;\n    width: 90%;\n    color: black;\n    text-align: center;\n}\n\n.dropdown-inputbox input::placeholder{\n    color: black;\n}\n\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n/* .dropdown-container2::-webkit-scrollbar {\n    display: none;\n} */\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
